module.exports = __webpack_public_path__ + "static/img/Scott_Pendlebury_mobile.11579b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Scott_Pendlebury_mobile.jpg
// module id = TZDs
// module chunks = 0